import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import StatusBadge from './StatusBadge';

const LeadTableRow = ({ lead }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const handleNavigateToDetails = (e) => {
    e?.stopPropagation();
    
    // Validate lead ID before navigation
    if (!lead?.id) {
      console.error('Cannot navigate to lead details: Lead ID is missing', lead);
      alert('Unable to view lead details: Lead ID is missing. Please refresh the page and try again.');
      return;
    }
    
    console.log('Navigating to lead details with ID:', lead?.id);
    navigate(`/lead-details/${lead?.id}`);
  };

  const handleRowClick = () => {
    // Validate lead ID before navigation
    if (!lead?.id) {
      console.error('Cannot navigate to lead details: Lead ID is missing', lead);
      alert('Unable to view lead details: Lead ID is missing. Please refresh the page and try again.');
      return;
    }
    
    console.log('Row clicked - Navigating to lead details with ID:', lead?.id);
    navigate(`/lead-details/${lead?.id}`);
  };

  return (
    <tr 
      className={`transition-colors duration-200 ${lead?.id ? 'hover:bg-muted/20 cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
      onClick={lead?.id ? handleRowClick : undefined}
    >
      <td className="px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="User" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <p className="font-medium text-foreground">{lead?.customerName}</p>
            <p className="text-sm text-muted-foreground">{lead?.email}</p>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 text-foreground">{lead?.propertyType}</td>
      <td className="px-6 py-4 text-foreground">{lead?.referralType}</td>
      <td className="px-6 py-4 text-foreground">{formatDate(lead?.submissionDate)}</td>
      <td className="px-6 py-4">
        <StatusBadge status={lead?.status} />
      </td>
      <td className="px-6 py-4">
        <Button 
          variant="ghost" 
          size="sm" 
          iconName="Eye" 
          iconPosition="left"
          onClick={handleNavigateToDetails}
          disabled={!lead?.id}
        >
          View
        </Button>
      </td>
    </tr>
  );
};

export default LeadTableRow;